import UiElement from '../../../shared/ui-element/ui-element';
import Carousel from '../../components/carousel/carousel';
import breakpoints from '../../config/breakpoints';

export enum TabsCategories {
  Utilities = 'utilities',
  Productivity = 'productivity',
  PhotoAndVideo = 'photo-and-video',
  Music = 'music',
  Books = 'books',
}

class SetappMobileCarousel extends UiElement {
  private setappMobileCarousel: Carousel;

  static activeTab = 'carousel__tab_active';

  private tabsCategoriesRangeMap = {};

  constructor() {
    super();

    this.ui = {
      setappMobileScreenshotsSlider: '.js-setapp-mobile-screenshots-slider',
      slidesContainer: '.js-carousel-slide-container',
    };

    this.uiCollections = {
      tabs: '.js-carousel-tab',
      carouselArrow: '.carousel__arrow',
    };

    this.events = {
      'click @uiCollections.tabs': 'handleClickTab',
    };
  }

  onInit() {
    super.onInit();

    this.updateCategoryRangeMap();

    window.addEventListener('resize', this.updateCategoryRangeMap);

    if (this.ui.setappMobileScreenshotsSlider) {
      this.setappMobileCarousel = new Carousel({
        rootElement: this.ui.setappMobileScreenshotsSlider,
        loop: false,
        onSlideChangeCallback: this.handleSlideChange,
        slidesPerPage: {
          [breakpoints.xs]: 1.2,
          [breakpoints.md]: 1.5,
          [breakpoints.lg]: 3,
        },
      });

      this.setappMobileCarousel.init();

      // Siema carousel adds style to slides by default
      // If we want slides to overflow screen, we need to change it
      if (this.ui.slidesContainer) {
        this.ui.slidesContainer.style.overflow = 'visible';
      }
    }
  }

  handleClickTab = (event: Event) => {
    const tabs = this.uiCollections.tabs as unknown as HTMLButtonElement[];

    const target = event.currentTarget as HTMLButtonElement;
    const category = target.dataset.tabCategory as TabsCategories;

    tabs.forEach((tab) => {
      tab.classList.remove(SetappMobileCarousel.activeTab);
    });

    target.classList.add(SetappMobileCarousel.activeTab);

    this.setappMobileCarousel.carousel.goTo(this.tabsCategoriesRangeMap[category][0]);
  };

  handleSlideChange = () => {
    const { currentSlide } = this.setappMobileCarousel.carousel;
    const tabs = this.uiCollections.tabs as unknown as HTMLButtonElement[];

    const category = Object.keys(this.tabsCategoriesRangeMap).find((key) => {
      const [start, end] = this.tabsCategoriesRangeMap[key as TabsCategories];

      return currentSlide >= start && currentSlide < end;
    });

    tabs.forEach((tab) => {
      tab.classList.remove(SetappMobileCarousel.activeTab);

      if (tab.dataset.tabCategory === category) {
        tab.classList.add(SetappMobileCarousel.activeTab);
      }
    });
  };


  private updateCategoryRangeMap = () => {
    /* Because Siema return current slide as float number for mobile screens,
     * we need to update range map based on screen width to match the current slide
     */
    const { innerWidth } = window;

    let musicEnd: number;

    if (innerWidth <= breakpoints.md) {
      musicEnd = 19.8;
    } else if (innerWidth <= breakpoints.lg) {
      musicEnd = 19.5;
    } else {
      musicEnd = 18;
    }

    const booksStart = musicEnd;

    this.tabsCategoriesRangeMap = {
      [TabsCategories.Utilities]: [0, 6],
      [TabsCategories.Productivity]: [6, 15],
      [TabsCategories.PhotoAndVideo]: [15, 17],
      [TabsCategories.Music]: [17, musicEnd],
      [TabsCategories.Books]: [booksStart, 21],
    };
  };
}

export default SetappMobileCarousel;
